export class CollectorConverter {
  convertEvents() {}
}
